<template>
  <j-select-biz-component :width="1000" v-bind="configs" v-on="$listeners" :selectButtonText="selectButtonText"/>
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'

  export default {
    name: 'JSelectUserSign',
    components: { JSelectBizComponent },
    props: [
      'value','queryDept','disable'
    ],
    data() {
      this.test();
      return {
        selectButtonText:"",
        settings: {
          name: '代理人',
          displayKey: 'workNo',
          returnKeys: ['username', 'id','workNo','email'],
          listUrl: '/sys/user/modalListWithDept'+"/"+this.queryDept,
          queryParamCode: 'workNo',
          queryParamText: '工号',
          queryDept:this.queryDept,
          multiple: false,
          disabled:this.disabled,
          rowKey:"workNo",
          columns: [
            { title: '姓名', dataIndex: 'realname', align: 'center', width: '20%' },
            { title: '用户名', dataIndex: 'username', align: 'center', width: '20%' },
            { title: '工号', dataIndex: 'workNo', align: 'center', width: '35%' },
            { title: '邮箱', dataIndex: 'email', align: 'center', width: '25%' }
          ]

          /*displayKey: 'name',
          returnKeys: ['name', 'id'],
          listUrl: '/sys/position/list',
          queryParamCode: 'name',
          queryParamText: '用户名',
          columns: [
            { title: '用户名', dataIndex: 'name', align: 'center', width: '30%', widthRight: '70%' },
            { title: '手机号', dataIndex: 'code', align: 'center', width: '35%' },
          ]*/

        }
      }
    },
    computed: {
      configs() {
        return Object.assign({ value: this.value }, this.settings, this.$attrs)
      }
    },
    methods:{
      test(){
        console.log("select1111122",this.queryDept);
      }
    }
  }
</script>

<style lang="less" scoped></style>